import AgencyLogo from './agency-logo';

export default AgencyLogo;
